import type { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function PageHeader({
  title,
  right,
  showBack,
  backTo,
  titleClassName,
}: {
  title: string;
  right?: ReactNode;
  showBack?: boolean;
  backTo?: string;
  titleClassName?: string;
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const shouldShowBack = showBack ?? (location.pathname !== "/" && location.pathname !== "/login");

  const onBack = () => {
    const historyIndex = typeof window.history.state?.idx === "number" ? window.history.state.idx : 0;
    if (historyIndex > 0) {
      navigate(-1);
      return;
    }
    navigate(backTo ?? "/");
  };

  return (
    <header className="page-header">
      <div className="page-header-side">
        {shouldShowBack ? (
          <button type="button" className="page-back-button" onClick={onBack} aria-label="戻る">
            戻る
          </button>
        ) : null}
      </div>
      <h1 className={`page-title${titleClassName ? ` ${titleClassName}` : ""}`} style={{ margin: 0 }}>
        {title}
      </h1>
      <div className="page-header-side page-header-side-right">{right}</div>
    </header>
  );
}
